import { render } from "./fee-rate-notice.vue?vue&type=template&id=4426d0c0&scoped=true"
import script from "./fee-rate-notice.vue?vue&type=script&lang=js"
export * from "./fee-rate-notice.vue?vue&type=script&lang=js"

import "./fee-rate-notice.vue?vue&type=style&index=0&id=4426d0c0&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4426d0c0"]])

export default __exports__